import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useSelector } from "react-redux";
import {
  DealerLocation,
  MatchedProduct,
} from "../../../models/features/Integration/DmsSetup";
import { AppState } from "../../../redux/reducer/rootReducer";
import AppGrid from "../../app/AppGrid";
import AppConfirmDialog from "../../app/AppConfirmDialog";
import { useDispatch } from "react-redux";
import {
  removeMatchProduct,
  useSaveSetupMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useGetProductByIdMutation } from "../../../redux/reducer/features/Product/productSlice";
import PageLoader from "../../app/PageLoader";
import { Product } from "../../../models/features/Product/Product";
import {
  setSetupOnCreate,
  setSetupId,
  RefreshTokenApi,
} from "../../../redux/reducer/features/Auth/authSlice";
import ProductDetail from "./Popup/ProductDetail";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { AppGridId } from "../../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../../services/utilities/utility";
import { Dispatch } from "@reduxjs/toolkit";
interface InitializeShopifyProps {
  handleBack: any;
  locations: DealerLocation[];
}

const InitializeShopify: React.FunctionComponent<InitializeShopifyProps> = ({
  handleBack,
  locations,
}) => {
  const gridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Create_Setup_Shopify_Initialization
    )
  );
  const dispatch = useDispatch<Dispatch<any>>();
    const refreshToken = useSelector((state: AppState) => state.authReducer.refreshToken);
  const { typeToProcess } = useSelector((state: AppState) => state.dmsReducer);
  const { locationIds } = useSelector((state: AppState) => state.dmsReducer);
  const [confirmDialog, setConfirmDialog] = React.useState(false);
  const [setupFailed, setSetupFailed] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState<Product>();
  const [selectedItem, setSelectedItem] = React.useState<MatchedProduct>();
  const [stock, setstock] = React.useState<any>([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedPartRows, setSelectedPartRows] = React.useState([]);
  const [Formopen, setFormOpen] = React.useState(false);
  const { matchedProducts, shopifyAccessToken, shopifyUrl } = useSelector(
    (state: AppState) => state.dmsReducer
  );
  const [whoolegoods] = React.useState(
    matchedProducts.filter((n) => n.dmsProduct)
  );
  const [parts] = React.useState(matchedProducts.filter((n) => n.dmsPart));
  const [value, setValue] = React.useState(typeToProcess[0] ?? "Wholegoods");
  const { dmsDealerId, dealerId, everestDmsDealerId } = useSelector(
    (state: AppState) => state.authReducer
  );
  const { mappedLocations, dmsManufacturers } = useSelector(
    (state: AppState) => state.dmsReducer
  );
  const [saveSetupMutation, saveSetupMutationResult] = useSaveSetupMutation();
  const onDialogClose = () => {
    setConfirmDialog(false);
  };
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductByIdMutation();
  const onDialogSuccess = () => {
    dispatch(removeMatchProduct(selectedItem as MatchedProduct));
    setConfirmDialog(false);
  };
  const handleClose = () => {
    setFormOpen(false);
  };
  const Products: MatchedProduct[] = [];
  const handleFinish = () => {
    Products.length = 0;
    selectedRows.forEach((values: any) => Products.push(whoolegoods[values]));
    selectedPartRows.forEach((values: any) => Products.push(parts[values]));
    saveSetupMutation({
      data: {
        dmsLocations: mappedLocations.filter((loc) =>
          locationIds.some((item) => item === loc.dealerId.toString())
        ),
        matchingProducts: Products,
        shopifyUrl: shopifyUrl ?? "",
        shopifyAccessToken: shopifyAccessToken ?? "",
        dmsDealerId: dmsDealerId ?? "",
        productTypes: typeToProcess,
        dealerId: dealerId ?? "",
        everestDmsDealerId: everestDmsDealerId ?? "",
        dmsManufacturers: dmsManufacturers,
      },
    });
  };

  React.useEffect(() => {
    if (productByIdMutationResult.isSuccess) {
      setSelectedProduct(productByIdMutationResult.data.entity);
    }
  }, [productByIdMutationResult]);

  React.useEffect(() => {
    if (
      saveSetupMutationResult.isSuccess &&
      saveSetupMutationResult.data?.status === 0
    ) {
      dispatch(
        RefreshTokenApi(refreshToken ?? "", () => {
          dispatch(setSetupId(saveSetupMutationResult.data?.entity?.id ?? ""));
          new Promise((resolve) => {
            dispatch(
              setSetupOnCreate({
                setup: saveSetupMutationResult.data.entity ?? {},
                callback: resolve,
              })
            );
          }).then(() => {
            setTimeout(() => {
              window.location.href = "/";
            }, 1000);
          });
        })
      );
    } else if (
      saveSetupMutationResult.data?.status === 10 ||
      saveSetupMutationResult.isError
    ) {
      setSetupFailed(true);
    }
  }, [saveSetupMutationResult]);
  const columns: GridColDef[] = [
    {
      field: "dmsProduct.mfgName",
      headerName: "Dms Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct.mfrCode + " - " + params.row.dmsProduct.mfgName,
    },
    {
      field: "catalogProduct.modelNumber",
      headerName: "Catalog Model Number",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.catalogProduct ? (
          <Typography
            onClick={(e) => {
              setFormOpen(true);
              productByIdMutation({
                data: { id: params.row.catalogProduct.id },
              });
              setstock(params.row.dmsProduct.locationCount);
            }}
            sx={{ cursor: "pointer" }}
            color="primary"
          >
            {params.row.catalogProduct?.modelNumber}
          </Typography>
        ) : (
          <Typography>N/A</Typography>
        );
      },
    },

    {
      field: "catalogProduct.title",
      headerName: "Catalog Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct ? params.row.catalogProduct?.title : "N/A",
    },
    {
      field: "catalogProduct.sku",
      headerName: "Catalog SKU",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct ? params.row.catalogProduct?.sku : "N/A",
    },
    {
      field: "catalogProduct.category.title",
      headerName: "Catalog Category",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.catalogProduct
          ? params.row.catalogProduct?.category?.title
          : params.row.dmsProduct.productLine,
    },
    {
      field: "dmsProduct.model",
      headerName: "Dms Model",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct?.model,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.catalogProduct ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : (
          <Chip label="DMS" color="warning" size="small" />
        );
      },
    },
    {
      field: "dmsProduct.price",
      headerName: "Price ($)",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.dmsProduct?.cost.toFixed(2),
    },
    {
      field: "dmsProduct.count",
      headerName: "Stock",
      align: "right",
      headerAlign: "right",
      type: "number",
      flex: 1,
      filterable: false,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) => {
        if (params.row?.dmsProduct.locationCount) {
          return params.row?.dmsProduct.locationCount?.reduce(
            (partial: number, value: any) => partial + value.count,
            0
          );
        } else {
          return 0;
        }
      },
    },
  ];

  const partColumns: GridColDef[] = [
    {
      field: "mfrName",
      headerName: "Manufacturer",
      flex: 1,
      valueGetter: (params: GridValueGetterParams<MatchedProduct>) =>
        params.row.mfrCode + " - " + params.row.mfrName,
    },
    {
      field: "inventoryPartId",
      headerName: "Part Id",
      flex: 1,
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "price",
      headerName: "Price ($)",
      headerAlign: "right",
      flex: 1,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "averageCost",
      headerName: "Cost ($)",
      headerAlign: "right",
      flex: 1,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.averageCost.toFixed(2),
    },
    {
      field: "availableQty",
      headerName: "Available Qty",
      flex: 1,
      filterable: false,
      type: "number",
    },
  ];
  return (
    <>
      <PageLoader isLoading={saveSetupMutationResult.isLoading}></PageLoader>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mt={2}
        mb={2}
      >
        <Alert severity="info">
          Selected Items will be sent to Product Sync, while all others will
          remain.
        </Alert>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button size="small" variant="outlined" onClick={handleBack}>
            Back
          </Button>
          <Button
            size="small"
            variant="contained"
            disabled={!(selectedRows.length > 0 || selectedPartRows.length > 0)}
            onClick={handleFinish}
          >
            Finish
          </Button>
        </Box>
      </Box>
      {setupFailed === true ? (
        <Alert
          sx={{ mt: 2 }}
          severity="error"
          onClose={() => {
            setSetupFailed(false);
          }}
        >
          Error occured while saving your setup
        </Alert>
      ) : (
        ""
      )}

      <Box height={565}>
        <TabContext value={value.toString()}>
          <TabPanel value="Wholegoods" style={{ padding: 0 }}>
            <AppGrid
              gridId={AppGridId.Create_Setup_Shopify_Initialization}
              data={whoolegoods.map((item, index) => ({
                id: index,
                ...item,
              }))}
              columns={GetAppGridColumns(
                columns,
                gridSetting?.columnVisibilityModel
              )}
              isLoading={false}
              selectedRows={selectedRows}
              onSelect={(newSelection: any) => {
                setSelectedRows(newSelection);
              }}
            ></AppGrid>
          </TabPanel>
          <TabPanel value="Parts" style={{ padding: 0 }}>
            <AppGrid
              data={parts
                .map((n) => n.dmsPart)
                .map((item, index) => ({
                  id: index,
                  ...item,
                }))}
              columns={partColumns}
              isLoading={false}
              selectedRows={selectedPartRows}
              onSelect={(newSelection: any) => {
                setSelectedPartRows(newSelection);
              }}
            ></AppGrid>
          </TabPanel>
        </TabContext>
      </Box>

      <AppConfirmDialog
        headerText="Are you sure?"
        bodyText="This part will be move to shopify store."
        onFail={onDialogClose}
        onSuccess={onDialogSuccess}
        handleClose={onDialogClose}
        isOpen={confirmDialog}
      />
      <ProductDetail
        isOpen={Formopen}
        handleClose={handleClose}
        productData={selectedProduct}
        Loading={productByIdMutationResult.isLoading}
        locations={locations}
      />
    </>
  );
};

export default InitializeShopify;
